import React from 'react'
import Alert from '../common/Alert'
import {Link} from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <Alert type="error" className="p-8">
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl">Page Not Found</h1>
        <p>
          There is no page at this URL. Please click the link below to return to
          your account.
        </p>
        <Link to="/" className="link">
          Return to Accounts Home
        </Link>
      </div>
    </Alert>
  )
}

export default NotFoundPage
